export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const LABEL = 'Label'
export const PARAGRAPH = 'Paragraph'
export const DROPDOWN = 'Dropdown'
export const CHECKBOX = 'Checkboxes'
export const RADIOBOX = 'RadioBoxes'
export const NUMBER_OF_FILES_ALLOWED_FOR_RETRY = 10;
export const SELECTED_COMPANY = 'selectedCompany';
export const SELECTED_ROLE = 'selectedRole';
export const SELECTED_LOCATION = 'selectedLocation';
export const USER_ID = 'userId';
export const USER_INITIALS = 'userInitials';
export const USER_EMAIL = 'userEmail';
export const ISSUER_CODE = 'issuerCode';
export const GRANT_TYPE = 'authorization_code';
export const GRANT_TYPE_REFRESH = 'refresh_token';
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const ACCESS_TOKEN_EXPIRES_AT = 'accessTokenExpiresAt';
export const REFRESH_TOKEN_EXPIRES_AT = 'refreshTokenExpiresAt';
export const ZONE_INFO = 'zoneInfo';
export const SELECTED_BOARD = 'selectedBoard';
export const CRP_TENANT_CODE = 'FS';
// CRR client secret is handled server-side via /ui/auth/sso/* endpoints
export const CODE_VERIFIER = 'code_verifier';
export const DOCUMENT_SERVICE_PROVIDER_CODE = 'DOCSER1';
export const COMPANY_REFERENCE = 'company_ref';
export const COMPANY_NAME = 'company_name';
export const COMPANY_INDEX = 'company_index';
export const CLIENT_NAME = '_clientName';
export const SERVICE_API_KEY = 'serviceApiKey';
export const DOCUMENT_SERVICE_ACCESS_TOKEN = '_documentServiceToken';
export const DOCUMENT_SERVICE_ACCESS_TOKEN_EXPIRY = '_documentServiceTokenExpiry';
export const SUPPORTED_FILE_FOR_TEMPLATE_CREATION = [".docx",".zpl",".doc"];
export const ENVs = {
    prod: 'production',
    staging: 'staging',
    test: 'test',
    qa: 'qa',
    demo: 'demo',
    uat: 'uat',
    dev: 'development',
};
export const CLIENT_NAME_MAP = {
    'Foundation Services Super Admin Company': 'datachain',
    'flow': 'targaryen'
};

export const USER_ROLES_MAP = {
    'USER' : 'User',
    'MS': 'FS Super Admin',
    'COMPADMIN': 'Company Admin',
    'ADMIN': 'Admin'
}

export const CRR_URLS = {
    [ENVs.dev] : 'https://dev-login.cargoes.com',
    [ENVs.qa] : 'https://dev-login.cargoes.com',
    [ENVs.test] : 'https://dev-login.cargoes.com',
    [ENVs.demo] : 'https://uat-login.cargoes.com',
    [ENVs.uat] : 'https://uat-login.cargoes.com',
    [ENVs.staging] : 'https://uat-login.cargoes.com',
    [ENVs.prod] : 'https://login.cargoes.com'
}

export const CRR_CLIENT_MANAGEMENT_URLS = {
    [ENVs.dev] : 'https://api-accountsdev.cargoes.com/clientmanagement-api',
    [ENVs.qa] : 'https://api-accountsdev.cargoes.com/clientmanagement-api',
    [ENVs.uat] : 'https://api-accountsuat.cargoes.com/clientmanagement-api',
    [ENVs.demo] : 'https://api-accountsuat.cargoes.com/clientmanagement-api',
    [ENVs.test] : 'https://api-accountsdev.cargoes.com/clientmanagement-api',
    [ENVs.staging] : 'https://api-accountsuat.cargoes.com/clientmanagement-api',
    [ENVs.prod] : 'https://api-accounts.cargoes.com/clientmanagement-api'
}

export const CRR_USER_MANAGEMENT_URLS = {
    [ENVs.dev] : 'https://api-accountsdev.cargoes.com/usermanagement-api',
    [ENVs.qa] : 'https://api-accountsdev.cargoes.com/usermanagement-api',
    [ENVs.uat] : 'https://api-accountsuat.cargoes.com/usermanagement-api',
    [ENVs.demo] : 'https://api-accountsuat.cargoes.com/usermanagement-api',
    [ENVs.test] : 'https://api-accountsdev.cargoes.com/usermanagement-api',
    [ENVs.staging] : 'https://api-accountsuat.cargoes.com/usermanagement-api',
    [ENVs.prod] : 'https://api-accounts.cargoes.com/usermanagement-api'
}

export const REDIRECT_URLS = {
    [ENVs.dev] : 'http://localhost:3000/login',
    [ENVs.qa] : 'https://qa-document-service.cargoes.com/login',
    [ENVs.test] : 'https://qa-document-service.cargoes.com/login',
    [ENVs.demo] : 'https://demo-document-service.cargoes.com/login',
    [ENVs.uat] : 'https://uat-document-service.cargoes.com/login',
    [ENVs.staging] : 'https://staging-document-service.cargoes.com/login',
    [ENVs.prod] : 'https://document-service.cargoes.com/login'

}

export const CRR_LOGIN_USER_BASE_PATH = {
    [ENVs.dev] : 'https://dev-accounts.cargoes.com',
    [ENVs.qa] : 'https://dev-accounts.cargoes.com',
    [ENVs.uat] : 'https://uat-accounts.cargoes.com',
    [ENVs.demo] : 'https://uat-accounts.cargoes.com',
    [ENVs.test] : 'https://dev-accounts.cargoes.com',
    [ENVs.staging] : 'https://uat-accounts.cargoes.com',
    [ENVs.prod] : 'https://accounts.cargoes.com'
}

export const CRP_MANGE_COMPANY_ENV_URLS = {
    [ENVs.dev]: {
      manageUsers: "https://dev-accounts.dpworld.com/user-search",
      manageCompany: "https://dev-accounts.dpworld.com/company-search",
    },
    [ENVs.qa]: {
      manageUsers: "https://dev-accounts.dpworld.com/user-search",
      manageCompany: "https://dev-accounts.dpworld.com/company-search",
    },
    [ENVs.staging] : {
      manageUsers: "https://uat-accounts.dpworld.com/user-search",
      manageCompany: "https://uat-accounts.dpworld.com/company-search",
    },
    [ENVs.prod]: {
      manageUsers: "https://accounts.dpworld.com/user-search",
      manageCompany: "https://accounts.dpworld.com/company-search",
    },
};
  